import { useEffect, useRef, useState } from 'react';
import { useStore } from '../../../../utils/store';

import Constants from '../../../../utils/constants';
import HttpService from '../../../../services/HttpService';
import StatusRequestData from '../../../../Models/StatusRequest';
import { useSearch } from '../../../../components/searchContext';
import {
  Box,
  Button,
  Checkbox,
  Paper,
  Typography,
  SortDirection,
} from '@mui/material';
import AddButtonComponent from '../../../../components/form/AddButtonComponent';
import CustomPaginationActionsTable from '../../../../components/TablePagination';

import FormFieldData from '../../../../Models/FormFieldData';
import SimpleDialogComponent from '../../../../components/SimpleDialogComponent';
import CommonForm from '../../../../components/form/CommonForm';
import IdLabelData from '../../../../Models/IdLabelData';
import DownloadIcon from '@mui/icons-material/Download';

import AlertMessageComponent from '../../../../components/AlertMessageComponent';
import SwitchComponent from '../../../../components/SwitchComponent';
import {
  downloadFile,
  getCurrentDate,
  getFormatDate,
} from '../../../../utils/storageUtil';
import { useAlert } from '../../../../components/alertContext';
interface MobileAssetDocumentsProps {
  mobileAssetId: number;
}
const AssetDocuments: React.FC<MobileAssetDocumentsProps> = ({
  mobileAssetId,
}) => {
  const { searchQuery } = useSearch();
  const isInitialLoad = useRef(true);
  const { getAdmin } = useStore();
  const [checkedIds, setCheckedIds] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [currentId, setCurrentId] = useState<number | string>(0);
  const [addNewDialogOpen, setAddNewDialogOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState<any>([]);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [documentTypeList, setDocumentTypeList] = useState<IdLabelData[]>([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  type formData = {
    [k: string]: { required: boolean; value: any };
  };

  const [form, setForm] = useState<formData>({
    id: { required: false, value: null },
    name: { required: true, value: '' },
    expiryDate: { required: true, value: getCurrentDate() },

    documentTypeId: { required: true, value: 0 },
    notes: { required: true, value: '' },
    documentFile: { required: true, value: [] },
  });
  const [orderBy, setOrderBy] = useState<any>('id');
  const [order, setOrder] = useState<SortDirection>('desc');
  const handleOrderBy = (orderByColumn: any) => {
    setOrderBy(orderByColumn);
    // console.log(order);
    // console.log(orderByColumn);
    if (order === 'desc') {
      setOrder('asc');
      return;
    } else {
      setOrder('desc');
      return;
    }
  };
  const columns: any[] = [
    {
      field: 'id',
      headerName: 'Date Uploaded',
      renderCell: (value: any, row: any) => (
        <Box sx={{ display: 'flex', alignItems: 'anchor-center' }}>
          <Checkbox
            edge="start"
            checked={checkedIds.includes(value)}
            tabIndex={-1}
            disableRipple
          />

          <Box sx={{ display: 'flex', alignItems: 'anchor-center' }}>
            {new Date(row.created).toLocaleDateString('default', {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
            })}
          </Box>
        </Box>
      ),
    },
    {
      field: 'expiryDate',
      headerName: 'Expiry Date',
    },
    {
      field: 'documentTypeName',
      headerName: 'Type',
    },
    {
      field: 'notes',
      headerName: 'Notes',
    },
  ];
  const handleStatus = (row: any, event: any) => {
    const classListArr: any = Array.from(event.target.classList);

    if (classListArr.indexOf('MuiSwitch-input') !== -1) {
      handleStatusInfo(row);
    } else {
      handleSelectedIds(row.id);
    }
  };
  const handleSelectedIds = async (id: any) => {
    console.log(id);
    setCheckedIds((prevItems: any) => {
      const newItems = [...prevItems];
      if (!newItems.includes(id)) {
        newItems.push(id);
      } else {
        newItems.splice(newItems.indexOf(id), 1);
      }
      return newItems;
    });
  };

  const [paginate, setPaginate] = useState<any>({
    limit: Constants.DEFAULT_PAGE_SIZE,
    offset: 0,
  });

  const clearForm = () => {
    setForm({
      id: { required: false, value: null },
      documentTypeId: { required: true, value: 0 },
      expiryDate: { required: true, value: getCurrentDate() },
      name: { required: true, value: '' },
      notes: { required: true, value: '' },
      documentFile: { required: true, value: [] },
    });
    setAddNewDialogOpen(false);
    fetchData();
  };

  const handleDownloadAll = async (IDs: any) => {
    const endpoint = `${Constants.apiURL + Constants.documentPDFsURL}/mobileasset/${mobileAssetId}`;
    let response: any;
    try {
      setIsDownloading(true);
      response = await HttpService.get(
        endpoint,
        {
          headers: {
            Authorization: `Bearer ${getAdmin()}`,
            Accept: 'application/pdf',
            accept: 'application/pdf',
          },
          responseType: 'blob',
        },
        { documentIds: IDs }
      );

      if (response) {
        downloadFile(response, `mobileasset_${mobileAssetId}.pdf`);
        setIsDownloading(false);
      }
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const fetchDocumentTypes = async () => {
    try {
      const URL = `${Constants.apiURL}${Constants.refBundleURL}/fetchDocumentTypes`;
      const response = await HttpService.get(
        URL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { type: 'mobileAsset' }
      );
      if (response.data) {
        setDocumentTypeList(response.data);
      }

      console.log('GET Response:', response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const handleUpdate = async () => {
    try {
      setIsLoading(true);
      const token = getAdmin();

      const formData = {
        id: form.id.value,
        name: currentRecord.name,
        documentTypeId: currentRecord.documentTypeId,
        expiryDate: getFormatDate(form.expiryDate.value),
        notes: form.notes.value,
        fileName: currentRecord.document.fileName,
        filePath: currentRecord.document.filePath,
      };

      const response = await HttpService.post(
        Constants.apiURL +
          Constants.documentURL +
          '/mobileasset?id=' +
          mobileAssetId,
        formData,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );
      if (response.success) {
        setIsLoading(false);
        clearForm();
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const handleSave = async () => {
    try {
      if (form.documentFile.value.length === 0) {
        setAlert({
          type: 'error',
          message: 'File is required',
          open: true,
        });
        return false;
      }
      const file: any = form.documentFile.value[0];
      if (file) {
        setIsLoading(true);
        const token = getAdmin();

        const signedData: any = await HttpService.handlePresignedDocument(
          file,
          'mobileasset',
          currentId,
          token
        );
        const formData = {
          documentTypeId: form.documentTypeId.value,
          expiryDate: form.expiryDate.value,
          name: form.name.value,
          notes: form.notes.value,
          filePath: signedData.filePath,
          fileName: signedData.fileName,
        };

        const response = await HttpService.post(
          Constants.apiURL +
            Constants.documentURL +
            '/mobileasset?id=' +
            mobileAssetId,
          formData,
          {
            headers: {
              Authorization: 'Bearer ' + token,
            },
          }
        );
        if (response.success) {
          setIsLoading(false);
          clearForm();
        }
        console.log('GET Response:', response);
      }
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const AddDialogContent = () => {
    return (
      <Box style={{ width: '500px' }}>
        <CommonForm
          singlePage={true}
          fields={formFields}
          onCancel={() => {
            clearForm();
          }}
          formReset={clearForm}
          formTitle={currentRecord ? 'Update Document' : 'Add New Document'}
          isLoading={isLoading}
          isUpdate={currentId !== 'Add' ? true : false}
          onSave={currentRecord ? handleUpdate : handleSave}
          actionButtonPosition="bottom"
        />
      </Box>
    );
  };
  const statusUpdate = async (dataObj: StatusRequestData) => {
    try {
      const response = await HttpService.patch(
        `${Constants.apiURL}${Constants.documentURL}/mobileasset`,
        dataObj,
        { headers: { Authorization: `Bearer ${getAdmin()}` } }
      );
      if (response.success) {
        fetchData();
        clearForm();
      }
      console.log('PATCH Response:', response);
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const handleStatusInfo = (row: any) => {
    let status = '1';
    if (row.status === '1') status = '0';
    if (row.status === '0') status = '1';
    statusUpdate({ id: row.id, status: status });
  };

  const handlePagination = (paginationData: any) => {
    console.log(paginationData);
    setPaginate(paginationData);
  };

  const fetchData = async () => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL}${Constants.documentURL}/mobileasset`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {
          id: mobileAssetId,
          search: searchQuery,
          limit: paginate.limit,
          offset: paginate.offset,
        }
      );
      if (response.success) {
        setRows(response.data.paginateRecords);
        setTotalRecords(response.data.total);
        handleOrderBy('id');
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setForm((prevData) => ({
      ...prevData,
      [name]: { ...prevData[name], value: value },
    }));
  };
  useEffect(() => {
    if (searchQuery || paginate || isInitialLoad.current) {
      fetchData();
    }
    isInitialLoad.current = false;
  }, [searchQuery, paginate]);
  useEffect(() => {
    if (documentTypeList.length === 0) fetchDocumentTypes();
  }, [mobileAssetId]);
  const handleFileChange = (file: any) => {
    setForm((prev: any) => {
      return {
        ...prev,
        documentFile: { required: prev['documentFile'].required, value: file },
      };
    });
  };
  const handleExpiryDate = (value: any) => {
    const expiryDateValue =
      value.year() + '-' + (value.month() + 1) + '-' + value.date();
    setForm((prevData) => ({
      ...prevData,
      ['expiryDate']: { ...prevData['expiryDate'], value: value },
    }));
  };
  const formFields: FormFieldData[] = [
    {
      name: 'name',
      label: 'Name',
      value: form.name.value,
      onChange: handleInputChange,
      isRequired: form.name.required,
      disabled: currentRecord ? true : false,
      size: 12,
      type: 'textfield',
      validationRules: [(value) => (!value ? 'Document name is required' : '')],
    },
    {
      name: 'documentTypeId',
      label: 'Document Type',
      value: form.documentTypeId.value,
      onChange: handleInputChange,
      isRequired: form.documentTypeId.required,
      disabled: currentRecord ? true : false,
      size: 12,
      type: 'selectField',
      options: documentTypeList,
      validationRules: [
        (value) => (!value ? 'Document Type is required' : null),
      ],
    },
    {
      name: 'expiryDate',
      label: 'Expiry Date',
      value: form.expiryDate.value,
      onChange: handleExpiryDate,
      isRequired: form.expiryDate.required,
      type: 'datepicker',
      size: 6,
      validationRules: [(value) => (!value ? 'Expiry date is required' : '')],
      keyname: 'expiryDateResource',
    },

    {
      name: 'notes',
      label: 'Notes',
      value: form.notes.value,
      minRows: 5,
      onChange: handleInputChange,
      isRequired: false,
      size: 12,
      type: 'textareaField',
    },
    {
      onChange: handleFileChange,
      value: [],
      name: 'documentFile',
      isRequired: false,
      label: 'Document File',
      multiple: true,

      isHidden: currentRecord ? true : false,
      type: 'file',
      size: 12,
      existingFiles: [],
      onRemoveFile: (file: any) => {
        //handleRemove(file, 'resource_product');
      },
      onRemoveExistingFile: (file: any) => {
        //handleRemoveFileUpdate(file, 'resource_product');
      },
      onOpenFile: (id) => {
        // handleDownloadFile(id);
      },
    },
  ];
  const handleRowClick = (record: any) => {
    // console.log(record);
    setCurrentRecord(record);
    setForm({
      id: { required: false, value: record.id },
      notes: { required: true, value: record.notes },
      name: { required: true, value: record.name },
      documentTypeId: { required: true, value: record.documentTypeId },
      expiryDate: { required: true, value: record.expiryDate },

      documentFile: { required: true, value: [] },
    });
  };
  return (
    <div className="containergrid">
      <div className="mt-2">
        <Paper sx={{ width: '100%' }} className="mt-4">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px',
              mb: 2,
            }}
          >
            <Typography variant="h6">Documents</Typography>
            <Box>
              <AddButtonComponent
                onClick={() => {
                  setCurrentId('Add');
                  setAddNewDialogOpen(true);
                }}
                keyName="checkIcon"
                label="Add new"
              />

              <Button
                style={{
                  textDecoration: 'none',
                  textTransform: 'capitalize',
                  color: 'rgba(0, 244, 255, 1)',
                  background: 'rgb(1, 1, 1)',
                  marginLeft: 3,
                }}
                disabled={isDownloading}
                variant="contained"
                startIcon={
                  <DownloadIcon sx={{ color: 'rgba(0, 244, 255, 1)' }} />
                }
                onClick={() => {
                  if (checkedIds.length > 0)
                    handleDownloadAll(checkedIds.join(','));
                  console.log(checkedIds);
                }}
              >
                {isDownloading ? 'Downloading...!' : 'Download'}
              </Button>
            </Box>
          </Box>
          <CustomPaginationActionsTable
            rows={rows}
            columns={columns}
            totalRecords={totalRecords}
            handlePagination={handlePagination}
            handleRowClick={(row) => {
              //  navigate('/data-management/mobile-assets/' + row.id);
              handleRowClick(row);
              setAddNewDialogOpen(true);
              console.log('row-clicked');
            }}
            paginationModel={{
              page: paginate.offset,
              pageSize: paginate.limit,
            }}
            handleStatus={handleStatus}
            order={order}
            orderBy={orderBy}
            handleOrderBy={handleOrderBy}
          />
          <SimpleDialogComponent
            title={''}
            dialogContent={AddDialogContent()}
            open={addNewDialogOpen}
            handleClose={() => {
              setAddNewDialogOpen(false);
            }}
          />
          <AlertMessageComponent
            type={alert.type}
            open={alert.open}
            handleClose={handleCloseAlert}
            message={alert.message}
          />
        </Paper>
      </div>
    </div>
  );
};

export default AssetDocuments;
